import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "containerRef",
    staticClass: "v-embed-container",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "v-embed-container__content"
  }, [_c('RatioBox', {
    style: {
      height: _vm.height
    },
    attrs: {
      "ratio": _vm.ratio
    }
  }, [_c('span', {
    staticClass: "v-embed-container__loader"
  }, [_c('CircularLoader', {
    attrs: {
      "color": _vm.loaderColorLocal,
      "size": "3rem"
    }
  })], 1), _vm._v(" "), _vm.lazy ? _c('Lazy', {
    attrs: {
      "rootMargin": "200px"
    }
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "id": _vm.id,
      "embed-type": _vm.embedType,
      "options": _vm.options,
      "track-video-play-events": _vm.trackVideoPlayEvents
    },
    on: {
      "loaded": _vm.handleResize,
      "event": function ($event) {
        return _vm.$emit('event', $event);
      }
    }
  })], 1) : [_vm.isOpen ? _c(_vm.component, {
    tag: "component",
    attrs: {
      "id": _vm.id,
      "embed-type": _vm.embedType,
      "options": _vm.options,
      "track-video-play-events": _vm.trackVideoPlayEvents
    },
    on: {
      "loaded": _vm.handleResize,
      "event": function ($event) {
        return _vm.$emit('event', $event);
      }
    }
  }) : _vm._e()]], 2)], 1), _vm._v(" "), _vm.options.showOpenButton && _vm.linkUrl ? _c('div', {
    staticClass: "v-embed-container__open"
  }, [_c('a', {
    staticClass: "v-embed-container__open__link",
    style: _vm.showButtonStyles,
    attrs: {
      "href": _vm.linkUrl,
      "target": "_blank",
      "rel": "noopener ugc"
    },
    on: {
      "click": _vm.handleEmbedClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.openButtonText) + "  \n      "), _c('span', {
    staticClass: "v-embed-container__open__icon"
  }, [_c('ChevronIcon', {
    attrs: {
      "direction": "right"
    }
  })], 1)])]) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-6b1a7ef2_0", {
    source: ".v-embed-container[data-v-6b1a7ef2]{border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);transition:visibility var(--c-container-transition-speed)}.v-embed-container__content[data-v-6b1a7ef2]{overflow:hidden}.v-embed-container__loader[data-v-6b1a7ef2]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.v-embed-container[data-v-6b1a7ef2]  iframe{border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);position:absolute;left:0;top:0;width:100%;height:100%;margin:0}.v-embed-container__open[data-v-6b1a7ef2]{text-align:center;margin:1rem auto 1rem}.v-embed-container__open__link[data-v-6b1a7ef2]{align-items:center;color:var(--c-open-color);font-family:var(--p-btn-font-family);font-weight:var(--p-btn-font-weight);font-size:.925rem;display:inline-flex;padding:.25rem .5rem;text-decoration:none}.v-embed-container__open__link span[data-v-6b1a7ef2]{transition:var(--g-transition-speed)}.v-embed-container__open__link[data-v-6b1a7ef2]:focus,.v-embed-container__open__link[data-v-6b1a7ef2]:hover{color:var(--c-open-color)}.v-embed-container__open__link:focus span[data-v-6b1a7ef2],.v-embed-container__open__link:hover span[data-v-6b1a7ef2]{transform:translateX(15%)}.v-embed-container__open__icon.v-embed-container__open__icon[data-v-6b1a7ef2]{display:inline-flex}.v-embed-container__open__icon.v-embed-container__open__icon .v-svg-icon[data-v-6b1a7ef2]{font-size:1.25rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-6b1a7ef2";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileEmbedContainer = __vue_component__;
export { ProfileEmbedContainer as default };